import { HTMLAttributes } from 'react'
import Link from 'next/link'

import Button from '@/components/base/Button'
import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Section from '@/components/base/Section'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { cn } from '@/lib/utils'
import { WPLink } from '@/types'

export type BannerProps = HTMLAttributes<HTMLElement> &
  Partial<{
    title_variant: TypographyProps['variant']
    title_component: TypographyProps['component']
    title: string
    paragraph: string
    button: WPLink
  }>

const Banner = ({
  title,
  title_variant,
  title_component,
  paragraph,
  button,
  className,
  ...props
}: BannerProps) => {
  return (
    <Section className={cn([className])} {...props}>
      <Container>
        <Grid>
          <div
            className={cn([
              'col-span-4 md:col-span-4 md:col-start-2 lg:col-span-6 lg:col-start-4',
              'md:group-[.modal]:col-span-6 lg:group-[.modal]:col-span-12',
              'rounded-[3rem] bg-white p-gutter md:text-center',
              'grid gap-y-[1.5rem]'
            ])}
          >
            {title ? (
              <Typography
                variant={title_variant}
                component={title_component}
                className="text-heading"
              >
                {title}
              </Typography>
            ) : null}

            {paragraph || button ? (
              <div className="grid gap-y-gutter">
                {paragraph ? (
                  <Typography
                    variant="body"
                    className="text-dark-blue [&_ul>br]:hidden [&_ul]:!pl-[1.5rem] md:[&_ul]:list-inside md:[&_ul]:!pl-[0rem]"
                  >
                    {paragraph}
                  </Typography>
                ) : null}

                {button ? (
                  <Button
                    variant="primary"
                    asChild
                    className="before:bg-heading"
                  >
                    <Link href={button.url} target={button.target}>
                      <span data-label={button.title}>
                        <Typography variant="label">{button.title}</Typography>
                      </span>
                    </Link>
                  </Button>
                ) : null}
              </div>
            ) : null}
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default Banner
